import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductAttributes } from "../../recommendation.types";
import { requestGetProductAttributes } from "./getProductAttributes.request";

const useProductAttributes = (
  id: string,
  options?: QueryOptions<ProductAttributes, ApiServiceError<ApiError>>
) => {
  const { data: attributes, ...rest } = useQuery({
    queryKey: ["recommendation", "enrichment", "detail", id],
    queryFn: async () => await requestGetProductAttributes(id),
    enabled: Boolean(id),
    retry: false,
    ...options
  });

  return { attributes, ...rest };
};

export default useProductAttributes;
